module.exports = __webpack_public_path__ + "img/metal_az@2x.d1cb775b.png";